/**
 * Hack to handle the top fixed bar with the property 1vh
 */
const setViewportHeight = () => {
  return(
    document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`)
  )
}

export default setViewportHeight